import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { CheckCircle2 } from "lucide-react";
import { currency } from "@/lib/format";

export default function PaymentReceipt({ receipt, onDone }) {
    return (
        <div className="mx-auto max-w-md px-4 py-12">
            <Card className="text-center" data-testid="payment-receipt">
                <CardContent className="p-8">
                    <div className="h-16 w-16 rounded-full bg-[hsl(var(--brand-sage)/0.18)] grid place-items-center mx-auto mb-3">
                        <CheckCircle2 className="h-8 w-8 text-[hsl(var(--brand-sage))]" />
                    </div>
                    <h1 className="font-display text-3xl">Thank you!</h1>
                    <p className="text-sm text-muted-foreground">{receipt.restaurant_name} · receipt</p>
                    <Separator className="my-4" />
                    <div className="text-left space-y-1 text-sm">
                        {receipt.line_items.map((li, index) => (
                            <div key={`${li.name}-${index}`} className="flex items-center justify-between">
                                <div>
                                    {li.quantity}× {li.name}
                                </div>
                                <div>{currency(li.line_total)}</div>
                            </div>
                        ))}
                    </div>
                    <Separator className="my-4" />
                    <div className="space-y-1 text-sm">
                        <Row label="Subtotal" value={currency(receipt.subtotal)} />
                        <Row label="Tax" value={currency(receipt.tax)} />
                        <Row label="Tip" value={currency(receipt.tip)} />
                        <div className="flex justify-between font-semibold pt-2 border-t border-border mt-2">
                            <span>Total</span>
                            <span data-testid="receipt-total">{currency(receipt.total)}</span>
                        </div>
                    </div>
                    <Button className="w-full mt-6" onClick={onDone} data-testid="receipt-done-button">
                        Done
                    </Button>
                </CardContent>
            </Card>
        </div>
    );
}

function Row({ label, value }) {
    return (
        <div className="flex justify-between">
            <span className="text-muted-foreground">{label}</span>
            <span>{value}</span>
        </div>
    );
}
